import * as Loadable from 'react-loadable'

import ModalLoading from '../modalLoading'

export default (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "addItemToCollectionModal" */ './addItemToCollectionContainer'),
  loading: ModalLoading,
  webpack: () => [require.resolveWeak('./addItemToCollectionContainer')],
  modules: ['./addItemToCollectionContainer']
})
